import axios from "axios";
import * as types from "../mutation-types";

import logger from "~/utilities/logger";

// state
export const state = {
  ufg_list: [],
  ufg_select: null,
  the_id: null,
};

// getters
export const getters = {
  ufg_list: (state) => state.ufg_list,
  check_list: (state) => state.ufg_list !== null,
  ufg_select: (state) => state.ufg_select,
  the_id: (state) => state.the_id,
};

//utils
export const getUFGIndexById = (state, ufgId) =>
  state.ufg_list.findIndex((ufg) => ufg.ufg_id.toString() === ufgId.toString());
export const getUFGByUfgId = (state, ufgId) =>
  state.ufg_list.find((ufg) => ufg.ufg_id.toString() === ufgId.toString());


// mutations
export const mutations = {
  [types.ADD_UFG](state, ufg)
  {
    return state.ufg_list.push(ufg);
  },
  [types.ADD_UFG_FAILURE](state, error) {},

  [types.FETCH_UFGS](state, { ufg_list })
  {
    return (state.ufg_list = ufg_list);
  },

  [types.FETCH_UFGS_FAILURE](state)
  {
    logger.error("FETCH_UFGS_FAILURE");
  },

  [types.FETCH_UFG](state, { ufg_select })
  {
    return (state.ufg_select = ufg_select);
  },

  [types.FETCH_UFG_FAILURE](state, { error })
  {
    logger.error("FETCH_UFG_FAILURE", error);
  },

  [types.SELECT_UFG](state, { ufg_id })
  {
    let theSelect = getUFGByUfgId(state, ufg_id);
    logger.log("store.SELECT_UFG", theSelect);
    return (state.ufg_select = theSelect);
  },

  [types.DESELECT_UFG](state)
  {
    return (state.ufg_select = null);
  },

  [types.DELETE_UFG](state, { ufg_id })
  {
    logger.log("store.DELETE_UFG", state, ufg_id);
    const index = getUFGIndexById(state, ufg_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete ufg (id ${ufg_id})`);
    }
    return state.ufg_list.splice(index, 1);
  },

  [types.UPDATE_UFG](state, { payload })
  {
    // state.ufg_select = payload.cou_name;
  },

  [types.SET_UFG_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_UFGS](state, { ufg_list })
  {
    return (state.ufg_list = ufg_list);
  },

  [types.SEARCH_UFGS_FAILURE](state, error)
  {
    logger.error("SEARCH_UFGS_FAILURE", error);
  },

  [types.ARCHIVE_UFG](state, { payload })
  {
    logger.log("store.ARCHIVE_UFG", state, payload.ufg_id);
    const index = getUFGIndexById(state, payload.ufg_id);
    if (index === -1)
    {
      return console.warn(`Unable to archive ufg (id ${org_id})`);
    }
    state.ufg_list[index] = payload;
    return state.ufg_list;
  },
};

// actions
export const actions = {
  async addUFG({ commit }, ufg)
  {
    try
    {
      logger.log("store.addUFG", "/api/ufg", ufg);
      const { data } = await axios.post("/api/ufg", ufg);
      if (data.status && data.status === "success")
      {
        logger.log("store.addUFG rsp", data);
        return commit(types.ADD_UFG, data.data);
      } else
      {
        return commit(types.DELETE_UFG_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("DELETE_UFG_FAILURE", e);
      return commit(types.DELETE_UFG_FAILURE, e);
    }
  },

  async getUFGS({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "&full=1";

      const { data } = await axios.get(
        `/api/ufg?paginate=${paginate}${extraOptions}`
      );
      logger.log("store.getUFGS", data);
      return commit(types.FETCH_UFGS, { ufg_list: data.data });
    } catch (e)
    {
      logger.error("store.getUFGS error", e);
      return commit(types.FETCH_UFGS_FAILURE);
    }
  },

  async getUFG({ commit, dispatch }, payload)
  {
    if (!payload.ufg_id) return;
    try
    {
      const { data } = await axios.get(`/api/ufg/${payload.ufg_id}`);
      logger.log("store.getUFG rsp", data);
      return commit(types.FETCH_UFG, { ufg_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_UFG_FAILURE, { error: e });
    }
  },

  async deleteUFG({ commit, dispatch }, payload)
  {
    if (!payload.ufg_id) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/ufg/${payload.ufg_id}${extraOptions}`
      );
      logger.log("store.deleteUFG rsp", data);
      return commit(types.DELETE_UFG, { ufg_id: payload.ufg_id });
    } catch (e)
    {
      logger.error("DELETE_UFG_FAILURE", e);
      // return commit(types.DELETE_UFG_FAILURE, { error: e });
    }
  },

  async archiveUFG({ commit, dispatch }, ufg_id)
  {
    try
    {
      const { data } = await axios.put(`/api/ufg/archive/${ufg_id}`);
      logger.log("store.updateUFG", data);
      return commit(types.ARCHIVE_UFG, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.ARCHIVE_UFG_FAILURE, { error: e });
    }
  },

  async updateUFG({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(`/api/ufg/${payload.ufg_id}`, payload);
      logger.log("store.updateUFG", data);
      return commit(types.UPDATE_UFG, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_UFG_FAILURE, { error: e });
    }
  },

  setUFGID({ commit, dispatch }, id)
  {
    return commit(types.SET_UFG_ID, { id: id });
  },

  async searchUFGS({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/ufg?search=${query}`);
      logger.log("store.searchUFGS", data);
      return commit(types.SEARCH_UFGS, { ufg_list: data.data.data });
    } catch (e)
    {
      logger.error("store.searchUFGS error", e);
      return commit(types.SEARCH_UFGS_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
